"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_components_1 = __importDefault(require("styled-components"));
var disabled_1 = __importDefault(require("src/utilities/styled/disabled"));
var round_1 = __importDefault(require("src/utilities/styled/round"));
var utilities_1 = require("src/components/Inputs/utilities");
var makeBorder_1 = __importDefault(require("src/components/Inputs/utilities/makeBorder"));
var makeBackground_1 = __importDefault(require("src/components/Inputs/utilities/makeBackground"));
var makeInputPadding_1 = __importDefault(require("src/components/Inputs/TextInput/utilities/makeInputPadding"));
var makePlaceholder_1 = __importDefault(require("src/components/Inputs/utilities/makePlaceholder"));
var makeColor_1 = __importDefault(require("src/components/Inputs/utilities/makeColor"));
var makeIconColor_1 = __importDefault(require("./utilities/makeIconColor"));
var makeInput = function (Component) {
    return (0, styled_components_1.default)(Component).attrs(function (_a) {
        var _b = _a.round, round = _b === void 0 ? 1 : _b;
        return ({
            round: round,
        });
    })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    width: 100%;\n\n    ::placeholder {\n      ", ";\n    }\n    \n    &:hover,\n    &:focus {\n      ", ";\n    }\n\n    &:focus {\n      & + div {\n        ", "\n      }\n    }\n  "], ["\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    width: 100%;\n\n    ::placeholder {\n      ", ";\n    }\n    \n    &:hover,\n    &:focus {\n      ", ";\n    }\n\n    &:focus {\n      & + div {\n        ", "\n      }\n    }\n  "])), utilities_1.baseStyles, makeBackground_1.default, disabled_1.default, function (_a) {
        var messageType = _a.messageType;
        return (0, makeBorder_1.default)({ active: false, messageType: messageType });
    }, round_1.default, makeInputPadding_1.default, makeColor_1.default, makePlaceholder_1.default, function (_a) {
        var messageType = _a.messageType;
        return (0, makeBorder_1.default)({ active: true, messageType: messageType });
    }, (0, makeIconColor_1.default)({ active: true }));
};
exports.default = makeInput;
var templateObject_1;
